import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

import { PromoDangerouslyHtml } from './PromoDangerouslyHtml';

const RichTextWrapper = styled.div`
    .rich-text-h1 {
        font-size: 40px;
        line-height: 46px;
        font-weight: 500;
        margin-bottom: 12px;
        /* для новостей можно будет поменять отступы в заголовках */

        ${promoMedia.desktop1440} {
            font-size: 56px;
            line-height: 125%;
            margin-bottom: 24px;
        }
    }
    .rich-text-h2 {
        font-size: 32px;
        line-height: 38px;
        font-weight: 500;
        margin-bottom: 12px;

        ${promoMedia.desktop1440} {
            font-size: 44px;
            line-height: 125%;
            margin-bottom: 24px;
        }
    }
    .rich-text-h3 {
        font-size: 24px;
        line-height: normal;
        font-weight: 500;
        margin-bottom: 12px;

        ${promoMedia.desktop1440} {
            font-size: 36px;
            line-height: 125%;
            margin-bottom: 24px;
        }
    }
    .rich-text-h4 {
        font-size: 20px;
        line-height: normal;
        font-weight: 500;
        margin-bottom: 12px;

        ${promoMedia.desktop1440} {
            font-size: 32px;
            line-height: 125%;
            margin-bottom: 24px;
        }
    }
    .rich-text-h6 {
        font-size: 18px;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 12px;

        ${promoMedia.desktop1440} {
            font-size: 21px;
            line-height: 28px;
            margin-bottom: 24px;
        }
    }
    .rich-text-p {
        font-size: 14px;
        line-height: 20px;

        ${promoMedia.desktop1440} {
            font-size: 16px;
            line-height: 24px;
        }
    }

    ul {
        margin-bottom: 12px;
        margin-left: 24px;

        ${promoMedia.desktop1440} {
            margin-bottom: 24px;
        }

        li {
            list-style: disc outside;

            ol {
                margin-left: 48px;

                li {
                    list-style: inherit;
                }
            }
        }
    }

    ol li {
        list-style: inherit;
    }

    p + p {
        margin-top: 0;
    }

    p {
        margin-bottom: 12px;

        ${promoMedia.desktop1440} {
            margin-bottom: 24px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    a,
    a:link,
    a:visited,
    a > span {
        color: ${promoColors.primary};
        word-break: break-word;

        &:hover {
            text-decoration: underline;
        }
    }

    hr {
        background: ${promoColors.gray40};
        margin: 32px 0;
    }

    table {
        max-width: 100%;

        td {
            padding: 0;
        }

        ${promoMedia.desktop1440} {
            td {
                padding: 4px;
            }
        }

        ul {
            margin-left: 14px;
        }
    }
`;

export const RichText = (props) => {
    return (
        <RichTextWrapper data-testid={props.dataTestId}>
            <PromoDangerouslyHtml
                variant={props.variant}
                tag={props.tag}
                color={props.color}
                gradientColor={props.gradientColor}
                nowrap={props.nowrap}
                ellipsis={props.ellipsis}
                textAlign={props.textAlign}
                isBold={props.isBold}
                dangerouslyHtml={props.dangerouslyHtml}
            />
        </RichTextWrapper>
    );
};

RichText.propTypes = {
    dangerouslyHtml: PropTypes.string,
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'subheader', 'quote', 'div', 'span', 'link', 'label', 'note']),
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'div', 'span', 'link', 'label', 'p']),
    color: PropTypes.oneOf(['baseColor', 'primary', 'primaryB2B', 'purple80', 'purple40', 'purple20', 'gray80', 'gray40', 'gray20', 'white']),
    gradientColor: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    nowrap: PropTypes.bool,
    ellipsis: PropTypes.bool,
    textAlign: PropTypes.string,
    isBold: PropTypes.bool,
    dataTestId: PropTypes.string,
};
